module.exports = __webpack_public_path__ + "fonts/OpenSans-Medium.e627ba86.ttf";